import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { class: "p-input-icon-left" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: {"width":"100%"},
    class: "p-m-2"
  }, {
    content: _withCtx(() => [
      _createVNode(_component_DataTable, {
        paginator: true,
        rows: 10,
        selection: _ctx.selectedMode.associatedRoles,
        "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedMode.associatedRoles = $event)),
        value: _ctx.roles,
        class: "p-datatable-sm kn-table",
        dataKey: "id",
        responsiveLayout: "stack",
        filters: _ctx.filters,
        "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
        filterDisplay: "menu",
        "data-test": "values-list"
      }, {
        header: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.filters['global'].value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters['global'].value = $event)),
                placeholder: _ctx.$t('common.search'),
                badge: "0",
                "data-test": "filter-input"
              }, null, 8, ["modelValue", "placeholder"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            headerStyle: "width: 3rem"
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: "Roles",
            class: "kn-truncated"
          })
        ]),
        _: 1
      }, 8, ["selection", "value", "filters"])
    ]),
    _: 1
  }))
}